// Lars Timer Code Starts

document.addEventListener("DOMContentLoaded", function() {
  function updateDeliveryDate() {
    let now = new Date();
    let currentHour = now.getHours();
    let deliveryDay;
    let daysToAdd;
    let nextDeadlineHour;
    
    
    
    // Finden Sie die nächste Deadline basierend auf der aktuellen Uhrzeit
    if (currentHour < 10) {
      nextDeadlineHour = 10;
    } else if (currentHour < 14) {
      nextDeadlineHour = 14;
    } else if (currentHour < 18) {
      nextDeadlineHour = 18;
    } else if (currentHour < 22) {
      nextDeadlineHour = 22;
    } else {
      nextDeadlineHour = 10; // am nächsten Tag
    }
    
    
    
    switch (now.getDay()) {
      // Montag bis Donnerstag
      case 1:
      case 2:
      case 3:
      case 4:
      if (currentHour < 10) {
        daysToAdd = 1;
      } else {
        daysToAdd = 2;
      }
      break;
      
      
      
      // Freitag
      case 5:
      if (currentHour < 10) {
        daysToAdd = 1;
      } else {
        daysToAdd = 3;
      }
      break;
      
      
      
      // Samstag
      case 6:
      if (currentHour < 10) {
        daysToAdd = 2;
      } else {
        daysToAdd = 3;
      }
      break;
      // Sonntag
      case 0:
        daysToAdd = 2;
      break;
      
      default:
      daysToAdd = 2;
    }
    
    let deliveryDate = new Date();
    deliveryDate.setDate(now.getDate() + daysToAdd);
    let weekdays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    deliveryDay = weekdays[deliveryDate.getDay()];
    
    // Update Countdown bis zur nächsten Deadline
    let hoursUntilDeadline = nextDeadlineHour - currentHour - 1; // -1, weil wir die volle Stunde nicht mitzählen
    let minutesUntilDeadline = 59 - now.getMinutes();
    let secondsUntilDeadline = 59 - now.getSeconds();
    
    document.getElementById('time').innerText = String(hoursUntilDeadline).padStart(2, '0') + ':' + String(minutesUntilDeadline).padStart(2, '0') + ':' + String(secondsUntilDeadline).padStart(2, '0');
    $('.dataArea p i').text(deliveryDay);
    // document.getElementById('delivery-day').innerText = deliveryDay;
  }
  
  if (document.getElementById('time')) setInterval(updateDeliveryDate, 1000);
});

// Lars Timer Code Ends




